import { Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => (
	<CssColumnGrid columns={2}>
		<Text semiBold text="localized" />
		<Text semiBold text="not localized" />
		<Text res="Resource" resParams={["Text"]} />
		<Text text="Centric Software" />
	</CssColumnGrid>
);
